const toBool = value => value === true || value === 'true';

export const selectFeatureFlagsLoaded = state => state.data.featureFlags.loaded;

// (fail-closed: OFF when the flag is missing or the bootstrap fetch failed).
// Returns a primitive, so useSelector/connect can compare by value safely.
export const selectFeatureFlag = (flagName, defaultValue = false) => state => {
  const { flags } = state.data.featureFlags;
  if (flags && Object.prototype.hasOwnProperty.call(flags, flagName)) {
    return toBool(flags[flagName]);
  }
  return defaultValue;
};
